// const segwit = require('./crypto/segwit_addr');
// const base58 = require('./crypto/base58');
import BTCValidator from './bitcoin_validator';

const TEMP_VALIDATOR = {
    name: 'LiteCoin',
    symbol: 'ltc',
    addressTypes: { prod: ['30', '05', '32'], testnet: ['6f', 'c4', '3a'] },
    validator: BTCValidator,
};

function isValidLtcAddress(address) {
    // do regular bitcoin regex
    // do bech32

    // const addressLen = address.length;

    // if (addressLen > 43 || addressLen < 26) {
    //     return false;
    // }
    // if (address[0] == 'L') {
    //     return base58.decode(address);
    // }

    // // P2SH Address - Deprecated
    // if (address[0] == '3') {
    //     return False;
    // }

    // // P2SH Address
    // if (address[0] == 'M') {
    //     return base58.decode(address);
    // }

    // P2WPKH Bech32 (Segwit)
    // todo fix this
    if (address.toLowerCase().substr(0, 4) == 'ltc1') {
        return true;
    }

    return false;
}

export default {
    isValidAddress(address, currency, networkType) {
        return (
            TEMP_VALIDATOR.validator.isValidAddress(
                address,
                currency,
                networkType,
                TEMP_VALIDATOR.addressTypes,
            ) || isValidLtcAddress(address)
        );
    },
};
